import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IBankingIconProps extends ISvgIconProps {

}

export class BankingIcon extends React.Component<IBankingIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="currentColor">
                    <path d="M6 6.426a0.4 0.4 0 0 0 -0.4 0.4v9.6a0.4 0.4 0 0 0 0.4 0.4h12a0.4 0.4 0 0 0 0.4 -0.4v-9.6a0.4 0.4 0 0 0 -0.4 -0.4h-12m0 -1.2h12a1.6 1.6 0 0 1 1.6 1.6v9.6a1.6 1.6 0 0 1 -1.6 1.6h-12a1.6 1.6 0 0 1 -1.6 -1.6v-9.6a1.6 1.6 0 0 1 1.6 -1.6Z"/>
                    <path d="M19.081 10.334H4.8v-1.2h14.281Z"/>
                    <path d="M9.409 15.134h-2.208v-1.2h2.208Z"/>
                </g>
            </SvgIcon>
        );
    }
}
